<script>
  import Modal from "svelte-simple-modal";

  //import Container from "../widgets/Container.svelte";

  import { modal } from "../store.js";
</script>

<Modal show={$modal}>
</Modal>
